import { render } from "./OneTrustLoader.vue?vue&type=template&id=322af6c8"
import script from "./OneTrustLoader.vue?vue&type=script&lang=js"
export * from "./OneTrustLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__